<div class="row">
    <div class="col-xl-6">
        <div class="card mb-5">
            <div class="card-badges">
                <span class="badge badge-pill badge-warning h-auto px-3 py-1">Blog Posts</span>
            </div>
            <a [routerLink]="" class="image-title-overlay" title="...">
                <div class="image-title-overlay--bottom">
                    <h3 class="display-4 font-weight-bold m-0 text-white">
                        Medieval military methods
                    </h3>
                </div>
                <img alt="..." class="card-img-top" src="assets/images/stock-photos/stock-2.jpg"/>
            </a>
            <div class="card-body">
                <div class="d-flex justify-content-between mb-4">
                    <div class="d-flex align-items-center">
                        <div class="avatar-icon-wrapper mr-2">
                            <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                        </div>
                        <div>
                            <a [routerLink]="" class="font-weight-bold" title="...">Shanelle Wynn</a>
                            <span class="text-black-50 d-block">UI Engineer, Apple Inc.</span>
                        </div>
                    </div>
                    <div>
                        <button class="btn py-1 px-2 btn-neutral-secondary font-weight-bold" type="button">
                            <span class="text-success font-size-md">23</span>
                            <span class="d-block opacity-6 text-black font-size-xs">Reviews</span>
                        </button>
                    </div>
                </div>
                <p class="card-text">Costs for the walls depended on the material used. Wood would cost very little and
                    was quick to build, but was weak.</p>
                <p class="card-text">Stone was strong but very expensive and time-consuming to construct</p>
                <div class="d-flex justify-content-between pt-3">
                    <button class="btn btn-sm btn-neutral-first">
                        Learn more
                    </button>
                    <button class="btn btn-sm btn-link btn-link-danger">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box mb-5">
            <div class="card-header">
                <div class="card-header--title">
                    <small>Cards</small>
                    <b>Example scrolling card</b>
                </div>
                <div class="card-header--actions">
                    <a [routerLink]="" class="btn btn-sm btn-first">
                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                    </a>
                </div>
            </div>
            <perfect-scrollbar [autoPropagation]="true" class="scroll-area-lg shadow-overflow">
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                            <div class="avatar-icon-wrapper avatar-icon-lg mr-3"><span
                                    class="badge badge-circle badge-danger">Offline</span>
                                <div class="avatar-icon rounded">
                                    <img alt="..." src="assets/images/avatars/avatar7.jpg"/>
                                </div>
                            </div>
                            <div>
                                <a [routerLink]="" class="font-weight-bold" title="...">Kate Winchester</a>
                                <span class="text-black-50 d-block">Freelance Designer, Mutual Inc.</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="rounded-pill bg-neutral-success text-success px-3 py-1 h-auto font-size-sm font-weight-bold">Successful</span>
                        </div>
                    </div>
                    <p class="text-black-50 mb-0">
                        From its medieval origins to the digital era, learn everything there is to know about the
                        ubiquitous lorem ipsum passage learn everything there is.
                    </p>
                </div>
                <div class="divider"></div>
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                            <div class="avatar-icon-wrapper avatar-icon-lg mr-3"><span
                                    class="badge badge-circle badge-success">Online</span>
                                <div class="avatar-icon rounded">
                                    <img alt="..." src="assets/images/avatars/avatar1.jpg"/>
                                </div>
                            </div>
                            <div>
                                <a [routerLink]="" class="font-weight-bold" title="...">Solomon Mora</a>
                                <span class="text-black-50 d-block">
                                    <fa-icon [icon]="['far', 'clock']" class="opacity-7 mr-1"></fa-icon>
                                    2 days ago
                                </span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="rounded-pill bg-neutral-warning text-warning px-3 py-1 h-auto font-size-sm font-weight-bold">Pending</span>
                        </div>
                    </div>
                    <p class="text-black-50">
                        The purpose of lorem ipsum is to create a natural looking block of text (sentence, paragraph,
                        page, etc.) that doesn't distract from the layout.
                    </p>
                    <p class="text-black-50 mb-0">
                        A practice not without controversy, laying out pages with meaningless filler text can be very
                        useful when the focus is meant to be on design, not content.
                    </p>
                </div>
                <div class="divider"></div>
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                            <div class="avatar-icon-wrapper avatar-icon-lg mr-3">
                                <span class="badge badge-circle badge-success" tooltip="User Online">Online</span>
                                <div class="avatar-icon rounded">
                                    <img alt="..." src="assets/images/avatars/avatar5.jpg"/>
                                </div>
                            </div>
                            <div>
                                <a [routerLink]="" class="font-weight-bold" title="...">Milly Dougherty</a>
                                <span class="text-black-50 d-block">
                                    <fa-icon [icon]="['far', 'calendar-alt']" class="opacity-7 mr-1"></fa-icon>
                                    15 August 2021
                                </span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="rounded-pill bg-neutral-first text-first px-3 py-1 h-auto font-size-sm font-weight-bold">Investigation</span>
                        </div>
                    </div>
                    <p class="text-black-50 mb-0">
                        The purpose of lorem ipsum is to create a natural looking block of text from the layout laying
                        out pages with meaningless filler.
                    </p>
                </div>
                <div class="divider"></div>
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                            <div class="avatar-icon-wrapper avatar-icon-lg mr-3">
                                <span class="badge badge-position badge-position--bottom-center badge-circle-inner badge-warning">Idle</span>
                                <div class="avatar-icon rounded">
                                    <img alt="..." src="assets/images/avatars/avatar3.jpg"/>
                                </div>
                            </div>
                            <div>
                                <a [routerLink]="" class="font-weight-bold" title="...">Amy-Louise Mccaffrey</a>
                                <span class="text-black-50 d-block">
                                    <fa-icon [icon]="['far', 'clock']" class="opacity-7 mr-1"></fa-icon>
                                    2 days ago
                                </span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <span class="rounded-pill bg-neutral-danger text-danger px-3 py-1 h-auto font-size-sm font-weight-bold">Declined</span>
                        </div>
                    </div>
                    <p class="text-black-50 mb-0">
                        A practice not without controversy, laying out pages with meaningless filler text can be very
                        useful when the focus is meant to be on design, not content.
                    </p>
                </div>
                <div class="divider"></div>
            </perfect-scrollbar>
            <div class="card-footer d-block text-center bg-light p-3">
                <a [routerLink]="" class="m-2 btn btn-primary p-0 d-inline-block text-center font-size-xxl d-50 rounded"
                  tooltip="Menu Example">
                    <fa-icon [icon]="['far', 'building']" class="font-size-xl text-white"></fa-icon>
                </a>
                <a [routerLink]="" class="m-2 btn btn-success p-0 d-inline-block text-center font-size-xxl d-50 rounded"
                  tooltip="Menu Example">
                    <fa-icon [icon]="['far', 'question-circle']" class="font-size-xl text-white"></fa-icon>
                </a>
                <a [routerLink]="" class="m-2 btn btn-danger p-0 d-inline-block text-center font-size-xxl d-50 rounded"
                  tooltip="Menu Example">
                    <fa-icon [icon]="['far', 'user-circle']" class="font-size-xl text-white"></fa-icon>
                </a>
            </div>
        </div>
    </div>
</div>
